import {Injectable} from '@angular/core';
import {HttpService} from '../http.service';
import { environment } from 'src/environments/environment';
import {Menu} from '../../../shared-gen/Model/Menus/Menu';
import {PriceList} from '../../../shared-gen/Model/PriceLists/PriceList';
import {LanguagePack} from '../../../shared-gen/Model/Localization/LanguagePack';

/**
 * Web API for querying entities like images or the language pack.
 */
@Injectable({
	providedIn: 'root'
})
export class DataApi extends HttpService {

	/**
	 * Gets the URL for the image with the given ID.
	 * It can be used within the src-property of an img-tag for example.
	 */
	getImageUrl(imageID: string): string {
		return `${environment.serverUrl}/data/image/${imageID}`;
	}

	/**
	 * Gets the current language pack.
	 */
	async getLanguagePack(): Promise<LanguagePack> {
		return await this.get<LanguagePack>('data/languagepack');
	}

}
